import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { preAppService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useGetPreAppLinkMutation = () => {
	const dispatch = useDispatch();

	return useMutation(preAppService.getPreAppLink, {
		onSuccess(url) {
			navigator.clipboard.writeText(url);
			dispatch(
				uiActions.showSuccessNotification({
					title: "Link copied",
				}),
			);
		},
		onError(error: ErrorResponse) {
			dispatch(
				uiActions.showErrorNotification({
					title: getErrorMessage(error),
				}),
			);
		},
	});
};

export default useGetPreAppLinkMutation;
